import { RefObject } from "react";

export const formatWeekdayName = (
  weekDay: Date,
  options?: {
    locale?: {
      code: string;
    };
  },
) => weekDay.toLocaleDateString(options?.locale?.code, { weekday: "narrow" });

export const getIsTargetElementEqualToRef = (
  targetElement: EventTarget | null,
  ref: RefObject<HTMLElement>,
) => !ref.current || ref.current.contains(targetElement as Node);
